import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SystemEntity } from '@erp/shared-types';
import { orpc } from '@/api/rpc/client';

export function useSendRemittanceEmail() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...orpc.finance.payments.sendRemittanceEmail.mutationOptions(),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: orpc.finance.payments.listRemittanceEmails.queryKey({
          input: { paymentId: variables.paymentId },
        }),
      });
      queryClient.invalidateQueries({
        queryKey: orpc.core.entityAssociations.list.queryKey({
          input: {
            entityId: variables.paymentId,
            entityType: SystemEntity.PAYMENT,
          },
        }),
      });
    },
  });

  return {
    send: mutation.mutateAsync,
    isSending: mutation.isPending,
  };
}
